import React, { useEffect, useRef, useState } from 'react'
import { Redirect } from 'react-router-dom'
import { setPageId, updateElapsedTimeInSecs } from '../services/Metrics'
import { session } from '../load-config'

function TrackingPage(page, pageId, checkSessionId = true) {

  return (props) => {
    return (
      <TrackingPageComponent WrappedComponent={page} pageId={pageId} checkSessionId={checkSessionId} {...props} />
    )
  }
}

export default TrackingPage


function TrackingPageComponent(props) {
  const { WrappedComponent, pageId, checkSessionId } = props
  const intervalRef = useRef(null);
  const startTimeRef = useRef(Date.now());

  useEffect(() => {
    if (pageId) {
      setPageId({ pageId })
    }

    intervalRef.current = setInterval(() => {
      const elapsedTime = Math.floor((Date.now() - startTimeRef.current) / 1000);
      updateElapsedTimeInSecs(elapsedTime);
    }, 5000);

    return () => {
      clearInterval(intervalRef.current);
    };
  }, [])

  function handleSetPageId(id) {
    setPageId({ pageId: id })
    startTimeRef.current = Date.now();
    updateElapsedTimeInSecs(0);
  }
  
  return !checkSessionId || (checkSessionId && session.getSessionId()) ? (
    <WrappedComponent setPageId={handleSetPageId} {...props} />
  ) : <Redirect to="/" />
}
